<template>
  <section>
    <span
      class="primary cur billBtn"
      v-show="listData.length === 0"
      @click="add(0)"
      >添加油费</span
    >
    <qx-card-form
      :title="'油费' + (index + 1)"
      v-for="(item, index) in listData"
      :key="index"
    >
      <span slot="titleLeft">
        <template v-if="item.id">
          <span style="margin-left: 16px">
            <span
              :class="{
                'warning-bg': item.state === 0,
                'primary-bg': item.state === 3,
                'error-bg': item.state === 4,
                'success-bg': item.state === 5,
              }"
              style="color: #fff; padding: 3px"
              >{{ item.stateName }}</span
            >
          </span>
        </template>
        <span
          class="primary cur btn"
          @click="add(index)"
          v-show="index === listData.length - 1"
          >添加</span
        >
        <span
          class="error cur btn"
          @click="del(index)"
          v-show="!item.id && listData.length !== 1"
          >删除</span
        >
        <template v-if="item.paymentWay === 2">
          <span class="btn">现金加油记录上报</span>
          <span class="btn error"
            >此部分费用只做记录，不能报销；对于扫码加油的记录，不用在这里登记。</span
          >
        </template>
        <template v-else>
          <span class="btn">公司油卡加油费用上报</span>
          <span class="btn error"
            >此部分费用审核通过后会生成费用申请记录，无需在车辆费用申请中填报这部分费用</span
          >
        </template>
      </span>
      <FormBox
        ref="formBox"
        :initData="item"
        @handlePaymentWayChange="
          (paymentWay) => handlePaymentWayChange(paymentWay, index)
        "
      />
    </qx-card-form>
    <!-- <button @click="sub">测试</button> -->
  </section>
</template>

<script>
import FormBox from './formBox';
// import {
//   orderRepostCostQueryCard,
// } from 'api/operate';
export default {
  components: {
    FormBox,
  },
  data () {
    return {
      listData: [],

      cardNoSelectOptions: [],
      paymentWay: 0,
      otherFormData: {
        id: 0,
        costId: 0,
        isDoSave: true,
        isFullOilName: '',
        loadMileage: '',
        loadingKm: '',
      },
    };
  },
  methods: {
    handlePaymentWayChange (paymentWay, index) {
      this.listData[index].paymentWay = paymentWay;
    },
    add (index) {
      const newItem = {
        amount: '',
        oilRise: '',
        paymentWay: 1,
        cardNo: '',
        cardNoSelect: '',
        oilMileage: '',
        file: [],
        remark: '',
        state: 0,
        stateName: '',
        id: 0,
        // id: Symbol('item'),
      };
      this.listData.push(newItem);
      // this.listData.splice(index + 1, 0, newItem);
      setTimeout(() => {
        if (this.$refs.formBox && this.$refs.formBox[index + 1]) {
          const formBox = this.$refs.formBox[index + 1];
          formBox.baseForm.cardNoSelectOptions = this.cardNoSelectOptions;
          let defaultValue = 0;
          if (formBox.baseForm.cardNoSelectOptions && formBox.baseForm.cardNoSelectOptions[0]) {
            defaultValue = formBox.baseForm.cardNoSelectOptions[0].value;
          }
          formBox.$refs.baseForm.setVal('cardNoSelect', defaultValue);
          formBox.handleCardNoSelectChange();
        }
      }, 0);
    },
    del (index) {
      this.listData.splice(index, 1);
    },

    async getBindCard () {
      this.$emit('getBindCard');
      // const res = await orderRepostCostQueryCard({
      //   orderId: this.$route.query.id,
      // });
      // if (!res.failed) {
      //   if (res.oilCardNum && res.oilCardNum.length) {
      //     const cardNoSelectOptions = res.oilCardNum.map((cardNo) => ({
      //       label: cardNo,
      //       value: cardNo,
      //     })) || [];
      //     this.cardNoSelectOptions = [
      //       ...cardNoSelectOptions,
      //       {
      //         label: '其他',
      //         value: 0,
      //       },
      //     ];
      //     if (cardNoSelectOptions && cardNoSelectOptions.length) {
      //       for (let i = 0; i < this.$refs.formBox.length; i++) {
      //         const formBox = this.$refs.formBox[i];
      //         formBox.baseForm.cardNoSelectOptions = this.cardNoSelectOptions;
      //         formBox.$refs.baseForm.setVal('cardNoSelect', formBox.baseForm.cardNoSelectOptions[0].value);
      //       }
      //     }
      //   }
      // }
    },

    async setFormState () {
      if (this.listData && this.listData.length) {
        for (let i = 0; i < this.listData.length; i++) {
          const item = this.listData[i];
          const formBox = this.$refs.formBox[i];
          formBox.setDisabledByState(false);
          formBox.setRequiredByState(true);
          if (item.state === 0) {
            let bindCardNo = '';
            if (this.cardNoSelectOptions && this.cardNoSelectOptions.length) {
              for (let i = 0; i < this.cardNoSelectOptions.length; i++) {
                if (`${this.cardNoSelectOptions[i].value}` === `${item.cardNo}`) {
                  bindCardNo = item.cardNo;
                }
              }
            }
            if (bindCardNo) {
              formBox.$refs.baseForm.setVal('cardNoSelect', bindCardNo);
            } else {
              formBox.$refs.baseForm.setVal('cardNoSelect', 0);
              formBox.$refs.baseForm.setVal('cardNo', item.cardNo);
            }
            formBox.$refs.baseForm.setVal('state', item.state);
            formBox.$refs.baseForm.setVal('stateName', item.stateName);

            formBox.handleCardNoSelectChange();
          } else if (item.state === 3 || item.state === 5) {
            // 有 id 证明是详情接口返回的数据，要根据状态判断是否可修改
            formBox.setDisabledByState(true);
            formBox.setRequiredByState(false);
            // 已绑定卡
            let bindCardNo = '';
            if (this.cardNoSelectOptions && this.cardNoSelectOptions.length) {
              for (let i = 0; i < this.cardNoSelectOptions.length; i++) {
                if (`${this.cardNoSelectOptions[i].value}` === `${item.cardNo}`) {
                  bindCardNo = item.cardNo;
                }
              }
            }
            if (bindCardNo) {
              formBox.$refs.baseForm.setVal('cardNoSelect', bindCardNo);
            } else {
              formBox.$refs.baseForm.setVal('cardNoSelect', 0);
              formBox.$refs.baseForm.setVal('cardNo', item.cardNo);
            }
            formBox.$refs.baseForm.setVal('state', item.state);
            formBox.$refs.baseForm.setVal('stateName', item.stateName);
          }
          formBox.handleCardNoSelectChange();
          formBox.handlePaymentWayChange();
        }
      }
    },

    async handleSubData (cache) {
      let result = [];
      for (let i = 0; i < this.$refs.formBox.length; i++) {
        let formData;
        if (cache) {
          formData = await this.$refs.formBox[i].getVal();
        } else {
          formData = await this.$refs.formBox[i].sub();
        }
        if (!formData) {
          return null;
        } else {
          formData.file.forEach((item, index) => {
            formData[`fileId${index || ''}`] = item.id;
            formData[`fileUrl${index || ''}`] = item.url;
            formData[`fileUrl${index || ''}Path`] = item.url;
          });
          delete formData.file;
          result.push(formData);
        }
      }
      return {
        ...this.otherFormData,
        oilCostDataList: result,
      };
    },

    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async sub () {
      const res = await this.handleSubData();
      if (res) {
        res.oilCostDataListStr = JSON.stringify(res.oilCostDataList);
        delete res.etcCostDataList;
        delete res.oilCostDataList;
      }
      return res;
    },
    async init (data = {}) {
      this.listData = [];
      if (!data.oilCostDataList || data.oilCostDataList.length === 0) {
        this.listData = [{
          amount: '',
          oilRise: '',
          paymentWay: 1,
          cardNoSelect: '',
          cardNo: '',
          oilMileage: '',
          file: [],
          remark: '',
          state: 0,
          stateName: '',
          id: 0,
          // id: Symbol('item'),
        }];
      } else {
        this.listData = data.oilCostDataList.map((item) => {
          let file = [];
          Object.keys(item).forEach((key) => {
            if (key.indexOf('fileId') !== -1) {
              const fileIndex = key.substr(6) || '';
              if (item[`fileId${fileIndex}`]) {
                file.push({
                  id: item[`fileId${fileIndex}`],
                  url: item[`fileUrl${fileIndex}Path`],
                });
              }
            }
          });
          return {
            ...item,
            file,
          };
        });
      }
      this.setFormVal(this.otherFormData, data);
      await this.getBindCard();
      // await this.setFormState();
    },
  },
};
</script>

<style scoped lang="scss">
.btn {
  margin-left: 16px;
}
</style>
